import { Component, EventEmitter, OnInit, Output, viewChild } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatIcon } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import moment from 'moment'

@Component({
  selector: 'form-search-compras-historico',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatTooltip,
    MatOption,
    MatSelect,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
  ],
  templateUrl: './form-search-compras-historico.component.html',
  styleUrl: './form-search-compras-historico.component.scss',
  standalone: true,
})
export class FormSearchComprasHistoricoComponent implements OnInit {
  constructor(private formBuilder: FormBuilder) {}

  @Output() responseSearch = new EventEmitter()

  datepickerEnvioStart = viewChild<MatDatepicker<any>>('dateEnvioStart')
  datepickerEnvioEnd = viewChild<MatDatepicker<any>>('dateEnvioEnd')
  datepickerRetornoStart = viewChild<MatDatepicker<any>>('dateRetornoStart')
  datepickerRetornoEnd = viewChild<MatDatepicker<any>>('dateRetornoEnd')

  formSearch: FormGroup = new FormGroup({})

  // Tipo e desfecho são conjuntos fechados definidos no back, não cadastros: não há endpoint
  // de domínio para buscar.
  listTipo: any[] = [
    { id: 0, descricao: 'Todos' },
    { id: 1, descricao: 'Precificação' },
    { id: 2, descricao: 'Desconto' },
  ]
  listDesfecho: any[] = [
    { id: 0, descricao: 'Todos' },
    { id: 1, descricao: 'Precificado' },
    { id: 2, descricao: 'Recusado' },
    { id: 3, descricao: 'Cancelado' },
    { id: 4, descricao: 'Falha no processo de compras' },
    // 99 e não 4: "em aberto" não é um desfecho gravado, é a ausência de retorno
    { id: 99, descricao: 'Em aberto' },
  ]

  ngOnInit() {
    this.createForm()
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      codigoTg: [''],
      nomeCliente: [''],
      nomeConsultor: [''],
      tipoId: [''],
      desfechoId: [''],
      dateEnvioStart: [''],
      dateEnvioEnd: [''],
      dateRetornoStart: [''],
      dateRetornoEnd: [''],
    })
  }

  openDatepicker(
    type: 'dateEnvioStart' | 'dateEnvioEnd' | 'dateRetornoStart' | 'dateRetornoEnd',
  ) {
    if (type == 'dateEnvioStart') {
      this.datepickerEnvioStart()?.open()
    } else if (type == 'dateEnvioEnd') {
      this.datepickerEnvioEnd()?.open()
    } else if (type == 'dateRetornoStart') {
      this.datepickerRetornoStart()?.open()
    } else if (type == 'dateRetornoEnd') {
      this.datepickerRetornoEnd()?.open()
    }
  }

  createModel() {
    return {
      codigoTg: this.formSearch.get('codigoTg')!.value,
      nomeCliente: this.formSearch.get('nomeCliente')!.value,
      nomeConsultor: this.formSearch.get('nomeConsultor')!.value,
      // TipoId e DesfechoId são int não anuláveis no backend, string vazia quebra a desserialização
      tipoId: this.formSearch.get('tipoId')!.value || 0,
      desfechoId: this.formSearch.get('desfechoId')!.value || 0,
      dataEnvioInicio: this.formatDate('dateEnvioStart'),
      dataEnvioFim: this.formatDate('dateEnvioEnd'),
      dataRetornoInicio: this.formatDate('dateRetornoStart'),
      dataRetornoFim: this.formatDate('dateRetornoEnd'),
    }
  }

  private formatDate(
    control: 'dateEnvioStart' | 'dateEnvioEnd' | 'dateRetornoStart' | 'dateRetornoEnd',
  ) {
    const value = this.formSearch.get(control)!.value
    return value ? moment(value).format('DD/MM/YYYY') : ''
  }

  checkSearch() {
    const model: any = this.createModel()
    // tipoId/desfechoId zerados significam "Todos", não contam como filtro preenchido
    return Object.entries(model).some(([key, value]: [string, any]) =>
      key == 'tipoId' || key == 'desfechoId'
        ? value > 0
        : `${value ?? ''}`.trim().length > 0,
    )
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      this.responseSearch.emit({ search: true, model: this.createModel() })
    } else if (!search) {
      this.formSearch.reset({
        codigoTg: '',
        nomeCliente: '',
        nomeConsultor: '',
        tipoId: '',
        desfechoId: '',
        dateEnvioStart: '',
        dateEnvioEnd: '',
        dateRetornoStart: '',
        dateRetornoEnd: '',
      })
      this.responseSearch.emit({ search: false, model: this.createModel() })
    }
  }
}
